
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store/index";

// Models
import {AppPlayerResourcesExercisesListIndex} from "@/models/app/player/resources/exercises/list/index";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AppPlayerResourcesExercisesListFormLookupIndexVue from "@/views/app/player/resources/exercises/list/form/lookup.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  components: {
    ElRow,
    ElCol,
    AppPlayerResourcesExercisesListFormLookupIndexVue,
  },
})
export default class AppPlayerResourcesExercisesListIndexVue extends Vue {
  isLoading: boolean | null = false;

  exercises: Array<AppPlayerResourcesExercisesListIndex> = [];

  async getExercises(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/administration/exercises`,
      formData: {
        organization_id: store.getters.getOrganizationMember.organization_id,
      },
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.exercises = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    await this.getExercises();
  }
}
